import React from 'react';

import WsColors from '../../WsColors';

export interface WsFileIconProps {
  color?: string;
  width?: number;
  height?: number;
  variant?: IconVariant;
}

export enum IconVariant {
  CAREERPAGES,
  APP,
}

const WsFileUploadIcon: React.FC<WsFileIconProps> = ({
  width = 96,
  height = 96,
  variant = IconVariant.APP,
}) => {
  const fillColour = variant == IconVariant.CAREERPAGES ? WsColors.White : WsColors.TheBlues50;
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="48" cy="48" r="48" fill={fillColour} />
      <rect
        x="31.1973"
        y="39.0116"
        width="33.6046"
        height="23.5581"
        rx="3.5"
        fill="#ADE8F4"
        stroke="#48CAE4"
      />
      <rect
        x="31.372"
        y="37.3403"
        width="21.3256"
        height="26.3488"
        rx="1.5"
        transform="rotate(-27.5845 31.372 37.3403)"
        fill="white"
        stroke="#48CAE4"
      />
      <rect
        x="37.8447"
        y="45.9888"
        width="5.58139"
        height="1.67442"
        transform="rotate(-27.5845 37.8447 45.9888)"
        fill="#ADE8F4"
      />
      <rect
        x="33.9688"
        y="38.5684"
        width="7.81396"
        height="1.11628"
        transform="rotate(-27.5845 33.9688 38.5684)"
        fill="#CAF0F8"
      />
      <rect
        x="34.7432"
        y="40.0524"
        width="17.8605"
        height="1.11628"
        transform="rotate(-27.5845 34.7432 40.0524)"
        fill="#CAF0F8"
      />
      <rect
        x="38.8789"
        y="47.9675"
        width="5.58139"
        height="1.67442"
        transform="rotate(-27.5845 38.8789 47.9675)"
        fill="#ADE8F4"
      />
      <rect
        x="39.9131"
        y="49.9463"
        width="5.58139"
        height="1.67442"
        transform="rotate(-27.5845 39.9131 49.9463)"
        fill="#ADE8F4"
      />
      <rect
        x="40.9463"
        y="51.925"
        width="5.5814"
        height="1.67442"
        transform="rotate(-27.5845 40.9463 51.925)"
        fill="#ADE8F4"
      />
      <rect
        x="41.9805"
        y="53.9039"
        width="5.58139"
        height="1.67442"
        transform="rotate(-27.5845 41.9805 53.9039)"
        fill="#ADE8F4"
      />
      <rect
        x="43.0137"
        y="55.8827"
        width="5.5814"
        height="1.67442"
        transform="rotate(-27.5845 43.0137 55.8827)"
        fill="#ADE8F4"
      />
      <rect
        x="43.2871"
        y="43.1459"
        width="5.58139"
        height="1.67442"
        transform="rotate(-27.5845 43.2871 43.1459)"
        fill="#ADE8F4"
      />
      <rect
        width="5.5814"
        height="1.67442"
        transform="matrix(0.886329 -0.463056 0.463057 0.886328 44.3203 45.1246)"
        fill="#ADE8F4"
      />
      <rect
        width="5.58139"
        height="1.67442"
        transform="matrix(0.886328 -0.463057 0.463056 0.886329 45.3545 47.1034)"
        fill="#ADE8F4"
      />
      <rect
        x="46.3877"
        y="49.0822"
        width="5.5814"
        height="1.67442"
        transform="rotate(-27.5845 46.3877 49.0822)"
        fill="#ADE8F4"
      />
      <rect
        x="47.4219"
        y="51.0609"
        width="5.5814"
        height="1.67442"
        transform="rotate(-27.5845 47.4219 51.0609)"
        fill="#ADE8F4"
      />
      <rect
        x="48.4561"
        y="53.0397"
        width="5.5814"
        height="1.67442"
        transform="rotate(-27.5845 48.4561 53.0397)"
        fill="#ADE8F4"
      />
      <rect
        width="5.5814"
        height="1.67442"
        transform="matrix(0.886329 -0.463056 0.463057 0.886328 48.7285 40.3029)"
        fill="#ADE8F4"
      />
      <rect
        x="49.7617"
        y="42.2816"
        width="5.5814"
        height="1.67442"
        transform="rotate(-27.5845 49.7617 42.2816)"
        fill="#ADE8F4"
      />
      <rect
        width="5.58139"
        height="1.67442"
        transform="matrix(0.886329 -0.463056 0.463058 0.886328 50.7959 44.2604)"
        fill="#ADE8F4"
      />
      <rect
        width="5.5814"
        height="1.67442"
        transform="matrix(0.886329 -0.463056 0.463057 0.886328 51.8301 46.2391)"
        fill="#ADE8F4"
      />
      <rect
        x="52.8633"
        y="48.218"
        width="5.5814"
        height="1.67442"
        transform="rotate(-27.5845 52.8633 48.218)"
        fill="#ADE8F4"
      />
      <rect
        x="53.8975"
        y="50.1968"
        width="5.58139"
        height="1.67442"
        transform="rotate(-27.5845 53.8975 50.1968)"
        fill="#ADE8F4"
      />
      <rect
        x="34.6728"
        y="33.1928"
        width="21.3256"
        height="26.3488"
        rx="1.5"
        transform="rotate(-17.279 34.6728 33.1928)"
        fill="white"
        stroke="#ADE8F4"
      />
      <rect
        x="39.4941"
        y="42.8597"
        width="5.58139"
        height="1.67442"
        transform="rotate(-17.279 39.4941 42.8597)"
        fill="#ADE8F4"
      />
      <rect
        x="37.0078"
        y="34.8655"
        width="7.81395"
        height="1.11628"
        transform="rotate(-17.279 37.0078 34.8655)"
        fill="#CAF0F8"
      />
      <rect
        x="37.5049"
        y="36.4644"
        width="17.8605"
        height="1.11628"
        transform="rotate(-17.279 37.5049 36.4644)"
        fill="#CAF0F8"
      />
      <rect
        x="40.1572"
        y="44.9916"
        width="5.5814"
        height="1.67442"
        transform="rotate(-17.279 40.1572 44.9916)"
        fill="#ADE8F4"
      />
      <rect
        width="5.58139"
        height="1.67442"
        transform="matrix(0.954869 -0.297026 0.297025 0.95487 40.8203 47.1234)"
        fill="#ADE8F4"
      />
      <rect
        x="41.4834"
        y="49.2551"
        width="5.58139"
        height="1.67442"
        transform="rotate(-17.279 41.4834 49.2551)"
        fill="#ADE8F4"
      />
      <rect
        x="42.1465"
        y="51.387"
        width="5.5814"
        height="1.67442"
        transform="rotate(-17.279 42.1465 51.387)"
        fill="#ADE8F4"
      />
      <rect
        x="42.8096"
        y="53.5188"
        width="5.58139"
        height="1.67442"
        transform="rotate(-17.279 42.8096 53.5188)"
        fill="#ADE8F4"
      />
      <rect
        x="45.3564"
        y="41.0361"
        width="5.58139"
        height="1.67442"
        transform="rotate(-17.279 45.3564 41.0361)"
        fill="#ADE8F4"
      />
      <rect
        x="46.0195"
        y="43.168"
        width="5.58139"
        height="1.67442"
        transform="rotate(-17.279 46.0195 43.168)"
        fill="#ADE8F4"
      />
      <rect
        x="46.6826"
        y="45.2998"
        width="5.58139"
        height="1.67442"
        transform="rotate(-17.279 46.6826 45.2998)"
        fill="#ADE8F4"
      />
      <rect
        x="47.3457"
        y="47.4316"
        width="5.5814"
        height="1.67442"
        transform="rotate(-17.279 47.3457 47.4316)"
        fill="#ADE8F4"
      />
      <rect
        x="48.0088"
        y="49.5634"
        width="5.5814"
        height="1.67442"
        transform="rotate(-17.279 48.0088 49.5634)"
        fill="#ADE8F4"
      />
      <rect
        width="5.5814"
        height="1.67442"
        transform="matrix(0.954869 -0.297026 0.297024 0.95487 48.6729 51.6952)"
        fill="#ADE8F4"
      />
      <rect
        x="51.2188"
        y="39.2125"
        width="5.58139"
        height="1.67442"
        transform="rotate(-17.279 51.2188 39.2125)"
        fill="#ADE8F4"
      />
      <rect
        x="51.8828"
        y="41.3444"
        width="5.5814"
        height="1.67442"
        transform="rotate(-17.279 51.8828 41.3444)"
        fill="#ADE8F4"
      />
      <rect
        x="52.5459"
        y="43.4762"
        width="5.58139"
        height="1.67442"
        transform="rotate(-17.279 52.5459 43.4762)"
        fill="#ADE8F4"
      />
      <rect
        x="53.209"
        y="45.608"
        width="5.5814"
        height="1.67442"
        transform="rotate(-17.279 53.209 45.608)"
        fill="#ADE8F4"
      />
      <rect
        x="53.8721"
        y="47.7397"
        width="5.58139"
        height="1.67442"
        transform="rotate(-17.279 53.8721 47.7397)"
        fill="#ADE8F4"
      />
      <rect
        x="54.5352"
        y="49.8716"
        width="5.5814"
        height="1.67442"
        transform="rotate(-17.279 54.5352 49.8716)"
        fill="#ADE8F4"
      />
      <path
        d="M29.4707 51.2811C29.2333 49.2042 30.8576 47.3837 32.948 47.3837H39.7327C40.1562 47.3837 40.5763 47.4606 40.9724 47.6106L45.4635 49.3118C45.9728 49.5047 46.5129 49.6035 47.0575 49.6035H63.3964C65.5517 49.6035 67.1948 51.5327 66.8518 53.6605L65.3505 62.9755C65.0772 64.6716 63.6131 65.9186 61.8951 65.9186H34.2663C32.4871 65.9186 30.991 64.5837 30.7889 62.816L29.4707 51.2811Z"
        fill="#ADE8F4"
        stroke="#48CAE4"
      />
      <g clipPath="url(#clip0_70_86295)">
        <path
          d="M50.2322 32.093C47.3298 32.093 46.4182 30.4186 46.3252 29.5814L49.9531 28.4651L50.2322 32.093Z"
          fill="#CAF0F8"
        />
        <path
          d="M47.1622 29.3023C46.9389 28.8557 47.7203 27.9069 47.7203 27.9069L47.7203 27.3488C47.8744 26.7288 48.3427 26.7184 48.5575 26.7907C49.004 26.3442 49.4878 26.4186 49.6738 26.5116C50.1203 26.0651 50.604 26.1396 50.7901 26.2326C51.2366 26.0094 51.7203 26.1396 51.9064 26.2326L52.4645 27.3489C53.1343 28.9117 53.1157 30.4187 53.0226 30.9768L50.7901 32.0931C48.2785 31.814 47.4413 29.8605 47.1622 29.3023Z"
          fill="white"
        />
        <path
          d="M48.2786 30.6976C48.111 30.406 49.2492 30.5498 49.2492 30.5498C49.2492 30.5498 49.3948 30.2872 50.5111 30.6976C50.7902 30.6976 51.0693 30.5498 51.9065 30.1394C52.2417 29.8479 51.9443 29.5977 52.1855 28.465C52.5207 28.1735 52.0459 26.7299 52.1855 26.7906C52.5207 26.6448 52.604 28.1252 52.7437 28.186C52.8135 28.3074 52.8551 28.6185 53.0227 28.91C53.5256 29.9304 53.0926 30.8913 53.0227 31.2558L51.0693 32.093C49.1837 31.9107 48.4881 31.062 48.2786 30.6976Z"
          fill="#CAF0F8"
        />
        <path
          d="M51.1935 25.8072C51.1084 25.8486 51.0299 25.9023 50.9606 25.9667C50.793 25.7163 50.4015 25.6504 50.0275 25.8255C49.9123 25.8748 49.8079 25.9462 49.7202 26.0356C49.5969 25.9482 49.4515 25.8971 49.3006 25.8881C49.1497 25.879 48.9993 25.9125 48.8664 25.9846C48.7446 26.0351 48.6365 26.1141 48.5514 26.2148C48.4662 26.3156 48.4063 26.4352 48.3767 26.5638C48.2178 26.5483 48.0577 26.5765 47.9137 26.6453C47.7351 26.7149 47.591 26.8518 47.5122 27.0265C47.4333 27.2012 47.4261 27.3998 47.4921 27.5798L47.5848 27.7777C47.395 27.9726 46.8742 28.5875 47.0097 29.3301C47.1452 30.0727 47.8981 31.0353 48.794 31.6181C49.3883 31.9929 50.0433 32.2614 50.7297 32.4115C50.7746 32.42 50.821 32.414 50.8623 32.3945L53.111 31.3418C53.154 31.3211 53.1892 31.2869 53.2112 31.2445C53.4333 30.7018 53.4996 30.1079 53.4027 29.5296C53.334 28.7405 53.1146 27.972 52.7565 27.2656L52.1965 26.0695C52.0971 25.903 51.9362 25.7822 51.7486 25.7332C51.561 25.6842 51.3617 25.7107 51.1935 25.8072ZM52.365 27.4488C52.706 28.1155 52.9138 28.8422 52.9768 29.5884C53.0465 30.0576 53.0035 30.5366 52.8516 30.986L50.7356 31.9766C50.1293 31.8335 49.5506 31.5921 49.0223 31.262C48.1139 30.6638 47.532 29.7776 47.4252 29.2549C47.4083 29.0644 47.4315 28.8724 47.4934 28.6913C47.5552 28.5103 47.6543 28.3443 47.7843 28.2039L48.5631 29.8676C48.5874 29.9195 48.6314 29.9596 48.6852 29.9792C48.7391 29.9987 48.7986 29.996 48.8505 29.9717C48.9024 29.9474 48.9425 29.9035 48.962 29.8496C48.9816 29.7957 48.9789 29.7363 48.9546 29.6843L47.8836 27.3965C47.8357 27.2943 47.9101 27.119 48.0993 27.0304C48.2885 26.9418 48.4763 26.9918 48.5251 27.0962L49.1075 28.3401L49.4989 28.1569L48.8066 26.678C48.7781 26.6171 48.8605 26.4646 49.0519 26.375C49.2432 26.2854 49.4335 26.3236 49.461 26.3823L50.1624 27.8807L50.5539 27.6975L49.9695 26.4492L49.9942 26.4058C50.0485 26.3217 50.1264 26.2557 50.2183 26.216C50.4205 26.1214 50.5893 26.159 50.6137 26.2112L51.2755 27.6248L51.6691 27.4405L51.1733 26.3814C51.2222 26.2991 51.2956 26.2341 51.3833 26.1956C51.5703 26.1081 51.7658 26.1518 51.8095 26.2453L52.365 27.4488Z"
          fill="#00B4D8"
        />
      </g>
      <defs>
        <clipPath id="clip0_70_86295">
          <rect
            width="8.64453"
            height="8.64454"
            fill="white"
            transform="translate(44.0928 26.5488) rotate(-25.0858)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default WsFileUploadIcon;
